import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_DATE_RANGE_PICKER = 'DATE_RANGE_PICKER';

export interface DateRange {
  start?: string;
  end?: string;
}

export interface DateRangePickerModelConfig extends DynamicFormValueControlModelConfig<DateRange> {
  noFuture?: boolean;
  noPast?: boolean;
}

export class DateRangePickerModel extends DynamicFormValueControlModel<DateRange> {
  @serializable() readonly type: string = TYPE_DATE_RANGE_PICKER;
  @serializable() noFuture: boolean;
  @serializable() noPast: boolean;

  constructor(config: DateRangePickerModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.noFuture = Boolean(config.noFuture);
    this.noPast = Boolean(config.noPast);
  }
}
